import * as React from 'react';
import * as I18n from 'i18n-js';
import CoreLink from '@reverbdotcom/commons/dist/components/core_link';
import { CategoryConfig } from './category_data';
import URLHelpers from '../shared/url_helpers';

interface IProps {
  categoryItem: CategoryConfig;
  overrideUrl?: string;
  position: number;
}

export default function CategoryItem(props: IProps) {
  function getName() {
    return I18n.t(`discovery.taxonomy.${props.categoryItem.uuid}`);
  }

  function getPath() {
    if (props.overrideUrl) { return props.overrideUrl; }
    return URLHelpers.categoryPagePath(props.categoryItem.slug);
  }

  const { categoryItem, position } = props;

  return (
    <CoreLink
      to={getPath()}
      trackName="CategoriesRow"
      trackEntityType="category"
      trackEntityId={categoryItem.uuid}
      trackPosition={position}
      className="category-item"
    >
      <div
        className="category-item__image"
        style={{ backgroundImage: `url(${categoryItem.image_v2})` }}
      />
      <div className="category-item__footer">
        <div className="category-item__text">
          {getName()}
        </div>
      </div>
    </CoreLink>
  );
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/discovery/category_item.tsx